import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { collection, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './interviewDetails.css';
import LazyLoad from 'react-lazyload';
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import { FaFacebook, FaTwitter, FaInstagram, FaPinterest, FaCopy } from 'react-icons/fa';

const InterviewsDetails = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const videoRefs = useRef({});
  const [playingVideos, setPlayingVideos] = useState({});

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const docRef = doc(db, 'news', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setArticle({ id: docSnap.id, ...docSnap.data() });
        } else {
          throw new Error('No article found for this ID!');
        }
      } catch (error) {
        console.error('Error fetching article:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch((error) => console.error('Error playing video:', error));
            setPlayingVideos((prev) => ({ ...prev, [video.id]: true }));
          } else {
            video.pause();
            setPlayingVideos((prev) => ({ ...prev, [video.id]: false }));
          }
        });
      },
      { threshold: 0.5 }
    );

    Object.values(videoRefs.current).forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      Object.values(videoRefs.current).forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, [article]);

  const handlePlayPause = (videoId) => {
    const video = videoRefs.current[videoId];
    if (video) {
      if (playingVideos[videoId]) {
        video.pause();
      } else {
        video.play().catch((error) => console.error('Error playing video:', error));
      }
      setPlayingVideos((prev) => ({ ...prev, [videoId]: !prev[videoId] }));
    }
  };

  const getFirstTextSection = (article) => {
    if (!article?.sections) return article?.content || '';
    const firstTextSection = article.sections.find(section => section.type === 'text');
    return firstTextSection?.content || article?.content || '';
  };

  const renderContent = (content) => {
    if (typeof content === 'string') {
      return content.split(',').map((item) => item.trim());
    }
    return Array.isArray(content) ? content : [content];
  };

  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading projects...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading Interviews...</p>
      </div>
    );
  }
  


  const ImageArray = ({ images, layout = 'single' }) => {
    if (!images || images.length === 0) return null;
  
    return (
      <div className={`grid gap-4 ${layout === 'double' ? 'grid-cols-2' : 'grid-cols-1'}`}>
        {images.map((imageUrl, index) => (
          <div 
            key={index} 
            className="relative overflow-hidden aspect-video"
          >
            <img
              src={imageUrl}
              alt={`Gallery image ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="article_details">
      <div className="article__details-title section__padding-case-title">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div className='ulev__details-title-big'>
            {/* <h1 style={{color: '#000000', fontSize: "clamp(28px, 4vw, 38px)"}}><span>{article.title || 'No Title'}</span></h1> */}
            <h1 style={{color: '#CD3333', fontSize: "clamp(28px, 4vw, 38px)", fontFamily: "Poppins-SemiBold"}}><span>Interview with John D. Smith </span></h1>
            {/* <h2 style={{color: '#CD3333'}}>{article.subtitle || 'No Subtitle'}</h2> */}
            <h2 style={{fontSize: "32px", color: "#000"}}>Senior architect @WEBuild</h2>
          </div>
          {/* <div className="article__details-title-big" style={{ display: 'flex', flexDirection: 'column' }}>
            <h1 style={{ color: '#000000', fontFamily: "Poppins-SemiBold", fontSize: "clamp(28px, 4vw, 38px)" }}>
              <span>{article.title || 'No Title'}</span>
            </h1>
            
            <div className="article__details-title-actions" style={{ display: 'flex', alignItems: 'center' }}>
              <h2 style={{ color: '#000', marginBottom: '0' }}>{article.category || 'No Subtitle'}</h2>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="issue-details__social-link-art"
                style={{ color: '#CD3333', marginLeft: '10px' }}
              >
                <FaFacebook />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="issue-details__social-link-art"
                style={{ color: '#CD3333', marginLeft: '10px' }}
              >
                <FaTwitter />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="issue-details__social-link-art"
                style={{ color: '#CD3333', marginLeft: '10px' }}
              >
                <FaInstagram />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="issue-details__social-link-art"
                style={{ color: '#CD3333', marginLeft: '10px' }}
              >
                <FaPinterest />
              </a>
              <a
                href="#"
                className={`issue-details__social-link-art`}
                style={{ color: '#CD3333', marginLeft: '10px' }}
              >
                <FaCopy />
              </a>
            </div>
          </div> */}
          {/*  */}
        </div>
      </div>


      {article.coverMedia && (
        <div className="article__details-images" style={{ padding: '0' }}>
          <div className="single-image-section">
            {article.coverMedia.type === 'video' ? (
              <video
                ref={(el) => (videoRefs.current['cover'] = el)}
                id="cover"
                loop
                autoPlay
                muted
                playsInline
                onClick={() => handlePlayPause('cover')}
                style={{ cursor: 'pointer' }}
              >
                <source src={article.coverMedia.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <BlurhashImg src={article.coverMedia.url} placeholderColor="#888" />
            )}
          </div>
        </div>
      )}

      <div className="article__details-title-big section__padding-social" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <div className="article__details-title-actions" style={{ display: 'flex', alignItems: 'center' }}>
          <h2 style={{ color: '#CD3333', marginBottom: '0' }}>{article.category || 'No Subtitle'}</h2>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="issue-details__social-link-art"
            style={{ color: '#CD3333', marginLeft: '10px' }}
          >
            <FaFacebook />
          </a>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="issue-details__social-link-art"
            style={{ color: '#CD3333', marginLeft: '10px' }}
          >
            <FaTwitter />
          </a>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="issue-details__social-link-art"
            style={{ color: '#CD3333', marginLeft: '10px' }}
          >
            <FaInstagram />
          </a>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="issue-details__social-link-art"
            style={{ color: '#CD3333', marginLeft: '10px' }}
          >
            <FaPinterest />
          </a>
          <a
            href="#"
            className={`issue-details__social-link-art`}
            style={{ color: '#CD3333', marginLeft: '10px' }}
          >
            <FaCopy />
          </a>
        </div>
      </div> 

      {article.sections && article.sections.length > 0 && article.sections.map((section, index) => (
        <div key={index} className="article-more-details" id={`section-${index}`}>
          {section.type === 'text' && (
            <div className="ulev_morePD-contain sectiona__padding">
              <p className='ulev_morePD-other'></p>
              <div className='ulev_morePD-p'>
                <div 
                  dangerouslySetInnerHTML={{ __html: section.content }} 
                  className="ulev_morePD-content"
                  style={{color: "#000"}}
                />
              </div>
            </div>
          )}
          {section.type === 'image' && section.layout !== 'double' && (
            <div className="article__details-images image__padding" style={{ padding: '0rem 4.2rem 0rem 4.2rem' }}>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <BlurhashImg src={url} placeholderColor="#888" />
                </div>
              ))}
            </div>
          )}
          {section.type === 'image_pair' && (
            <div className="article__details-image-pair section__padding">
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="half-image-section">
                  <BlurhashImg src={url} placeholderColor="#888" />
                </div>
              ))}
            </div>
          )}
          {section.type === 'video' && section.layout === 'double' && (
            <div className="article__details-images section__padding article__details-images-double">
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single__image-section">
                  <video
                    ref={(el) => (videoRefs.current[`video-${index}-${idx}`] = el)}
                    id={`video-${index}-${idx}`}
                    loop
                    autoPlay
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video' && section.layout !== 'double' && (
            <div className="article__details-images" style={{ padding: '4rem 4rem 4rem 4rem' }}>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single__image-section">
                  <video
                    ref={(el) => (videoRefs.current[`video-${index}-${idx}`] = el)}
                    id={`video-${index}-${idx}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video_pair' && (
            <div className="article-details-video-pair section__padding-vid">
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="half-video-section">
                  <video
                    ref={(el) => (videoRefs.current[`video-pair-${index}-${idx}`] = el)}
                    id={`video-pair-${index}-${idx}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-pair-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'image_array' && (
            <ImageArray 
              images={section.images}
              layout={section.layout}
            />
          )}
        </div>
      ))}

      <div className="ulev_morePD-contain sectiona__padding">
        <p className='ulev_morePD-other'></p>
        <div className='ulev_morePD-p'>
          <div 
            className="ulev_morePD-content"
            style={{color: "#000"}}
          >
            <div
              className="right-container"
              style={{
                flex: "3.3", 
                padding: "1.5rem 0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <p></p> 
            </div>

            {/* Left Container */}
            <div
              className="project-info-container"
              style={{
                flex: "6.7",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "2rem",
              }}
            >
              {/* Project Info Content */}
              <div
                className="project-info-content"
                style={{
                  flex: "2",
                }}
              >
                <h2
                  style={{
                    fontFamily: "Syne",
                    color: "#CD3333",
                    fontSize: "clamp(20px, 4vw, 32px)",
                    fontWeight: "600",
                  }}
                >
                  Enjoying the article? share it with others
                </h2>
              </div>

              {/* Social Icons */}
              <div
                className="project-info-social-icons"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                  marginTop: "auto",
                  color: "#CD3333",
                }}
              >
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={24} />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <FaTwitter size={24} />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <FaPinterest size={24} />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <FaTwitter size={24} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="sectionar__padding"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: "2rem",
          flexWrap: "wrap", 
        }}
      >

        {/* Responsive Media Queries */}
        <style jsx>{`
          @media (max-width: 1024px) {
            .sectionar__padding {
              flex-direction: column; /* Stack everything */
              gap: 1.5rem;
            }
            .right-container,
            .project-info-container,
            .project-info-content {
              flex: 1 1 100%; /* Full width */
              text-align: center;
            }
            .project-info-container {
              flex-direction: column; /* Stack inner items */
              gap: 1.5rem;
            }
            .project-info-social-icons {
              justify-content: center;
              margin-top: 1rem;
            }
          }

          @media (max-width: 768px) {
            h2 {
              font-size: 18px;
            }
            .project-info-item h3 {
              font-size: 14px;
            }
            .project-info-social-icons a {
              font-size: 20px;
            }
          }
        `}</style>
      </div>

      

      {/* Move Related Articles section outside of the sections mapping */}
      {article.relatedProjects && article.relatedProjects.length > 0 && (
        <div className="section__padding">
          <h2 style={{
            fontFamily: "Poppins-SemiBold", 
            color: "#CD3333", 
            fontSize: "clamp(28px, 4vw, 36px)", 
            fontWeight: "600"
          }}>
            Related Articles
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {article.relatedProjects.map((relatedProject, index) => (
              <Link 
                key={index} 
                to={`/work/${relatedProject.slug}`} 
                className="mb-8 cursor-pointer duration-300"
              >
                <div>
                  <div className="h-[300px] w-full overflow-hidden">
                    <BlurhashImg
                      src={relatedProject.coverImage}
                      alt={relatedProject.title}
                      className="w-full h-full object-cover responsive blur_load"
                      loading="lazy"
                      placeholderColor="#888"
                      onError={(e) => {
                        console.error('Error loading image:', relatedProject.coverImage);
                        e.target.src = '/fallback-image.jpg';
                      }}
                    />
                  </div>
                  <div className="mt-4">
                    <p style={{
                      fontFamily: "Poppins-Regular",
                      color: "#CD3333",
                      fontSize: "16px"
                    }}>
                      {relatedProject.category || 'Project'}
                    </p>
                    <h3 style={{
                      fontFamily: "Poppins-SemiBold",
                      fontSize: "26px",
                      fontWeight: "600",
                      lineHeight: "1.2",
                      paddingTop: '6px'
                    }}>
                      {relatedProject.title}
                    </h3>
                    <p
                      dangerouslySetInnerHTML={{ 
                        __html: (() => {
                          const content = getFirstTextSection(article);
                          if (!content) return 'No content available';
                          return content.length > 250 ? content.slice(0, 250) + '...' : content;
                        })()
                      }}
                      style={{
                        fontFamily: "Poppins-Light", 
                        lineHeight: "1.3", 
                        color: "#000000", 
                        fontSize: '14px', 
                        paddingTop: '6px'
                      }}
                    ></p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InterviewsDetails;






